import { axiosInstance } from './api';

class AuthService {
  private accessToken: string | null = null;
  private refreshPromise: Promise<string | null> | null = null;

  setTokens(accessToken: string): void {
    this.accessToken = accessToken;
  }

  getAccessToken(): string | null {
    return this.accessToken;
  }

  clearTokens(): void {
    this.accessToken = null;
    this.refreshPromise = null;
  }

  hasValidTokens(): boolean {
    return this.accessToken !== null;
  }

  async refreshAccessToken(): Promise<string | null> {
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    this.refreshPromise = this.performRefresh();

    try {
      return await this.refreshPromise;
    } finally {
      this.refreshPromise = null;
    }
  }

  private async performRefresh(): Promise<string | null> {
    try {
      const response = await axiosInstance({
        method: 'POST',
        url: '/v1/refresh_jwt/',
        withCredentials: true,
      });

      if (response.status === 200 && response.data?.access) {
        this.accessToken = response.data.access;
        return this.accessToken;
      }
    } catch {
      this.clearTokens();
    }

    return null;
  }

  async initializeFromCookie(): Promise<boolean> {
    if (this.accessToken) {
      return true;
    }

    const accessToken = await this.refreshAccessToken();
    return accessToken !== null;
  }
}

export default new AuthService();
